export default {
  COMPLETE_ID: 1,
  INCOMPLETE_ID: 2,
};
